// extracted by mini-css-extract-plugin
module.exports = {"hidden":"MenuButton_hidden__1kS95","menu":"MenuButton_menu__38yxb","actionHasCalendarItemInput":"MenuButton_actionHasCalendarItemInput__34V0G"};